import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

import IncidentListRenderer from '@/components/Incidents/incident-list-renderer';
import OtherRelatedIncidents from '@/components/Incidents/other-related-incidents';
import StatusMessage from '@/components/shared/status-message';
import { useGetIncidentsByLineNumber } from '@/hooks/use-get-incidents-by-line-nummber';
import useGetJourneyData from '@/hooks/use-get-journey-data';
import { useRelatedIncidents } from '@/hooks/use-related-incidents';
import { ERROR_FEEDBACK } from '@/utils/constants';
import { SEARCH_PARAM_LOCK_PIN, SEARCH_PARAMS_ROUTE_ID } from '@/utils/constants/queries';

const RouteIncidentsList = ({ currentLineNumber }: { currentLineNumber: string }) => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const journeyId =
    searchParams.get(SEARCH_PARAMS_ROUTE_ID) ?? searchParams.get(SEARCH_PARAM_LOCK_PIN);
  const { data } = useGetJourneyData(journeyId!, { enabled: !!journeyId });

  const selectedDate = String(data?.journeyDate ?? new Date().toISOString().split('T')[0]);

  const {
    data: routeIncidents = [],
    isLoading,
    isError,
    refetch,
  } = useGetIncidentsByLineNumber(currentLineNumber, String(selectedDate));

  const { filteredMatchedIncidents, filteredOtherRelatedIncidents, isEmpty } =
    useRelatedIncidents(routeIncidents);

  if (isError) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center py-8">
        <StatusMessage
          type="error"
          title={t(ERROR_FEEDBACK.general)}
          description={t(ERROR_FEEDBACK.incidents.api)}
          showReloadButton
          onRetry={refetch}
        />
      </div>
    );
  }

  return (
    <div className="pt-2 h-full">
      <IncidentListRenderer data={filteredMatchedIncidents} isLoading={isLoading} isEmpty={isEmpty}>
        {!isLoading && <OtherRelatedIncidents incidents={filteredOtherRelatedIncidents} />}
      </IncidentListRenderer>
    </div>
  );
};

export default RouteIncidentsList;
